module.exports = __webpack_public_path__ + "img/icondefaultimage.aa22075a.png";